// Central mock data store

export const initialPages = [
  {
    id: 1,
    title: "Home",
    slug: "/",
    template: "Homepage",
    status: "published",
    lastModified: "Jan 18, 2025",
    author: "Alice M.",
    heroHeading: "Enterprise ERP Solutions",
    heroSubheading: "Transform your business with SAP",
    seoTitle: "ThynkProcess – Enterprise ERP",
    seoDescription: "Leading SAP partner",
  },
  {
    id: 2,
    title: "About Us",
    slug: "/about",
    template: "About",
    status: "published",
    lastModified: "Jan 15, 2025",
    author: "Bob K.",
  },
  {
    id: 3,
    title: "Contact Us",
    slug: "/contact",
    template: "Contact",
    status: "published",
    lastModified: "Jan 10, 2025",
    author: "Alice M.",
  },

  {
    id: 5,
    title: "Partner Program",
    slug: "/partners",
    template: "Landing",
    status: "draft",
    lastModified: "Jan 5, 2025",
    author: "David R.",
  },
  {
    id: 6,
    title: "Privacy Policy",
    slug: "/privacy",
    template: "Privacy",
    status: "published",
    lastModified: "Dec 20, 2024",
    author: "Alice M.",
  },
  {
    id: 7,
    title: "ERP Solutions Overview",
    slug: "/erp-solutions",
    template: "Overview",
    status: "scheduled",
    lastModified: "Jan 19, 2025",
    author: "Bob K.",
  },
  {
    id: 8,
    title: "Solutions",
    slug: "/solutions",
    template: "Solution",
    status: "scheduled",
    lastModified: "Jan 19, 2025",
    author: "Bob K.",
  },
  {
    id: 9,
    title: "Footer",
    slug: "-",
    template: "Footer",
    status: "scheduled",
    lastModified: "Jan 19, 2025",
    author: "Bob K.",
  },
  {
    id: 10,
    title: "Products",
    slug: "/products",
    template: "Products",
    status: "scheduled",
    lastModified: "Jan 19, 2025",
    author: "Bob K.",
  },
  {
    id: 11,
    title: "Services",
    slug: "/services",
    template: "Services",
    status: "scheduled",
    lastModified: "Jan 19, 2025",
    author: "Bob K.",
  },
  {
    id: 12,
    title: "Industries",
    slug: "/industries",
    template: "Industries",
    status: "scheduled",
    lastModified: "Jan 19, 2025",
    author: "Bob K.",
  },
  {
    id: 13,
    title: "Licensing Calculator",
    slug: "/licensing_calculator",
    template: "licensing_calculator",
    status: "scheduled",
    lastModified: "Jan 19, 2025",
    author: "Bob K.",
  },
  {
    id: 14,
    title: "Estimator Config",
    slug: "/estimator_config",
    template: "estimator_config",
    status: "scheduled",
    lastModified: "Jan 19, 2025",
    author: "Bob K.",
  },
  {
    id: 15,
    title: "Resources",
    slug: "/resources",
    template: "Resources",
    status: "scheduled",
    lastModified: "Jan 19, 2025",
    author: "Bob K.",
  },
  {
    id: 16,
    title: "Career",
    slug: "/careers",
    template: "Career",
    status: "scheduled",
    lastModified: "Jan 19, 2025",
    author: "Bob K.",
  },
  {
    id: 17,
    title: "Methodology",
    slug: "/methodology",
    template: "Methodology",
    status: "scheduled",
    lastModified: "Jan 19, 2025",
    author: "Bob K.",
  },
  {
    id: 18,
    title: "Partners",
    slug: "/partners",
    template: "Partners",
    status: "scheduled",
    lastModified: "Jan 19, 2025",
    author: "Bob K.",
  },
  {
    id: 18,
    title: "Change Partners",
    slug: "/change-partners",
    template: "ChangePartner",
    status: "scheduled",
    lastModified: "Jan 19, 2025",
    author: "Bob K.",
  },
  {
    id: 19,
    title: "FAQ",
    slug: "/faq",
    template: "FAQ",
    status: "scheduled",
    lastModified: "Jan 19, 2025",
    author: "Bob K.",
  },
  {
    id: 20,
    title: "Guides",
    slug: "/guides",
    template: "Guides",
    status: "scheduled",
    lastModified: "Jan 19, 2025",
    author: "Bob K.",
  },
  {
    id: 21,
    title: "Terms and Conditions",
    slug: "/terms",
    template: "Terms",
    status: "scheduled",
    lastModified: "Jan 19, 2025",
    author: "Bob K.",
  },
];

export const initialBlogPosts = [
  {
    id: 1,
    title: "The Complete Guide to SAP Business One Implementation",
    slug: "sap-b1-implementation-guide",
    category: "Implementation",
    tags: "SAP, ERP, Implementation",
    author: "Alice M.",
    status: "published",
    date: "Jan 18, 2025",
    views: "4.2K",
    featured: true,
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=60&h=40&fit=crop",
    excerpt: "A comprehensive guide to implementing SAP Business One.",
  },
  {
    id: 2,
    title: "Top 10 ERP Trends to Watch in 2025",
    slug: "erp-trends-2025",
    category: "Insights",
    tags: "ERP, Trends, 2025",
    author: "Bob K.",
    status: "scheduled",
    date: "Jan 22, 2025",
    views: "—",
    featured: false,
    image: null,
  },
  {
    id: 3,
    title: "How AI is Transforming SAP Workflows",
    slug: "ai-sap-workflows",
    category: "Technology",
    tags: "AI, SAP, Automation",
    author: "Carol S.",
    status: "draft",
    date: "Jan 19, 2025",
    views: "—",
    featured: false,
    image: null,
  },
  {
    id: 4,
    title: "SAP vs Oracle: Enterprise ERP Comparison 2025",
    slug: "sap-vs-oracle-2025",
    category: "Comparison",
    tags: "SAP, Oracle, Comparison",
    author: "David R.",
    status: "published",
    date: "Jan 10, 2025",
    views: "7.8K",
    featured: true,
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=60&h=40&fit=crop",
  },
  {
    id: 5,
    title: "Understanding SAP Business One Licensing",
    slug: "sap-b1-licensing",
    category: "Guides",
    tags: "SAP, Licensing",
    author: "Alice M.",
    status: "published",
    date: "Dec 28, 2024",
    views: "3.1K",
    featured: false,
    image: null,
  },
  {
    id: 6,
    title: "Manufacturing ERP Buyers Guide 2025",
    slug: "manufacturing-erp-guide-2025",
    category: "Guides",
    tags: "Manufacturing, ERP",
    author: "Bob K.",
    status: "published",
    date: "Dec 15, 2024",
    views: "5.4K",
    featured: true,
    image:
      "https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=60&h=40&fit=crop",
  },
];

export const initialResources = [
  {
    id: 1,
    title: "The Complete SAP Business One Buyer's Guide",
    slug: "sap-b1-buyers-guide",
    category: "Guide",
    type: "PDF",
    gated: true,
    featured: true,
    status: "published",
    downloads: 428,
    date: "Jan 15, 2025",
    description: "Everything you need to know before buying SAP Business One.",
  },
  {
    id: 2,
    title: "ERP Implementation Checklist 2025",
    slug: "erp-implementation-checklist",
    category: "Toolkit",
    type: "PDF",
    gated: false,
    featured: false,
    status: "published",
    downloads: 1204,
    date: "Jan 10, 2025",
  },
  {
    id: 3,
    title: "Manufacturing ROI Calculator",
    slug: "manufacturing-roi-calculator",
    category: "Workbook",
    type: "XLSX",
    gated: true,
    featured: true,
    status: "published",
    downloads: 317,
    date: "Dec 20, 2024",
  },
  {
    id: 4,
    title: "Digital Transformation Whitepaper",
    slug: "digital-transformation-whitepaper",
    category: "Whitepaper",
    type: "PDF",
    gated: true,
    featured: false,
    status: "draft",
    downloads: 0,
    date: "Jan 19, 2025",
  },
  {
    id: 5,
    title: "SAP vs Oracle Comparison Guide",
    slug: "sap-vs-oracle-guide",
    category: "Guide",
    type: "PDF",
    gated: false,
    featured: true,
    status: "published",
    downloads: 892,
    date: "Dec 5, 2024",
  },
  {
    id: 6,
    title: "ERP Migration Workbook",
    slug: "erp-migration-workbook",
    category: "Workbook",
    type: "XLSX",
    gated: true,
    featured: false,
    status: "published",
    downloads: 156,
    date: "Nov 28, 2024",
  },
  
];

export const initialEvents = [
  {
    id: 1,
    title: "AI-Powered SAP: The Future of ERP Automation",
    type: "Webinar",
    date: "2025-02-05",
    time: "14:00",
    timezone: "EST",
    status: "upcoming",
    speaker: "Dr. Raj Patel",
    speakerTitle: "CTO",
    speakerCompany: "ThynkProcess",
    registrations: 312,
    featured: true,
    registrationUrl: "https://example.com/reg1",
  },
  {
    id: 2,
    title: "ERP Summit 2025: Manufacturing & Distribution",
    type: "Conference",
    date: "2025-03-12",
    time: "09:00",
    timezone: "GMT",
    status: "upcoming",
    speaker: "Various Speakers",
    registrations: 870,
    featured: true,
  },
  {
    id: 3,
    title: "SAP Business One vs. SAP S/4HANA – Deep Dive",
    type: "Webinar",
    date: "2025-01-15",
    time: "15:00",
    timezone: "EST",
    status: "completed",
    speaker: "Alice Martinez",
    registrations: 445,
    featured: false,
    recordingUrl: "https://example.com/rec1",
  },
  {
    id: 4,
    title: "Cloud ERP Migration Best Practices",
    type: "Workshop",
    date: "2025-01-08",
    time: "10:00",
    timezone: "PST",
    status: "completed",
    speaker: "Bob Kumar",
    registrations: 198,
    featured: false,
  },
  {
    id: 5,
    title: "Digital Transformation for SMEs – Live Panel",
    type: "Panel",
    date: "2024-12-18",
    time: "14:00",
    timezone: "CET",
    status: "completed",
    speaker: "Panel of 4",
    registrations: 521,
    featured: true,
  },
  {
    id: 6,
    title: "February Live Q&A: SAP Implementation",
    type: "Q&A",
    date: "2025-02-20",
    time: "13:00",
    timezone: "EST",
    status: "upcoming",
    speaker: "Carol Sharma",
    registrations: 89,
    featured: false,
  },
];

export const initialSolutions = [
  {
    id: 1,
    title: "SAP for Manufacturing",
    category: "Industry",
    status: "published",
    date: "Jan 10, 2025",
    heroHeading: "Optimize Your Manufacturing with SAP",
  },
  {
    id: 2,
    title: "Cloud ERP Solutions",
    category: "Technology",
    status: "published",
    date: "Jan 8, 2025",
  },
  {
    id: 3,
    title: "Solutions for CFOs",
    category: "Role",
    status: "draft",
    date: "Jan 15, 2025",
  },
];

export const initialProducts = [
  {
    id: 1,
    title: "SAP Business One",
    status: "published",
    date: "Jan 5, 2025",
    heroHeading: "The #1 ERP for SMEs",
  },
  { id: 2, title: "SAP S/4HANA", status: "published", date: "Dec 20, 2024" },
  {
    id: 3,
    title: "SAP Analytics Cloud",
    status: "draft",
    date: "Jan 18, 2025",
  },
];

export const initialServices = [
  {
    id: 1,
    title: "SAP Implementation",
    status: "published",
    date: "Jan 3, 2025",
    heroHeading: "Expert SAP Implementation Services",
  },
  {
    id: 2,
    title: "SAP Support & Maintenance",
    status: "published",
    date: "Dec 15, 2024",
  },
  { id: 3, title: "ERP Consulting", status: "draft", date: "Jan 12, 2025" },
];

export const initialIndustries = [
  {
    id: 1,
    title: "Manufacturing",
    status: "published",
    date: "Jan 2, 2025",
    heroHeading: "ERP Solutions for Manufacturing",
  },
  {
    id: 2,
    title: "Retail & Distribution",
    status: "published",
    date: "Dec 10, 2024",
  },
  { id: 3, title: "Healthcare", status: "draft", date: "Jan 14, 2025" },
];

export const initialCaseStudies = [
  {
    id: 1,
    title: "Delta Corp ERP Transformation",
    client: "Delta Corp",
    industry: "Manufacturing",
    product: "SAP Business One",
    status: "published",
    date: "Jan 8, 2025",
    heroHeading: "45% Efficiency Gain with SAP B1",
    metrics: "45% efficiency, 30% cost reduction, 6 month ROI",
  },
  {
    id: 2,
    title: "Nile Industries Digital Overhaul",
    client: "Nile Industries",
    industry: "Distribution",
    product: "SAP S/4HANA",
    status: "published",
    date: "Dec 22, 2024",
  },
  {
    id: 3,
    title: "ApexTech Cloud Migration",
    client: "ApexTech",
    industry: "Technology",
    product: "SAP Analytics Cloud",
    status: "draft",
    date: "Jan 16, 2025",
  },
];

export const initialUsers = [
  {
    id: 1,
    name: "Alice Martinez",
    email: "alice@thynkprocess.com",
    role: "Admin",
    status: "Active",
    lastLogin: "Just now",
    avatar: "AM",
  },
  {
    id: 2,
    name: "Bob Kumar",
    email: "bob@thynkprocess.com",
    role: "Editor",
    status: "Active",
    lastLogin: "2h ago",
    avatar: "BK",
  },
  {
    id: 3,
    name: "Carol Sharma",
    email: "carol@thynkprocess.com",
    role: "Content Manager",
    status: "Active",
    lastLogin: "1d ago",
    avatar: "CS",
  },
  {
    id: 4,
    name: "David Reyes",
    email: "david@thynkprocess.com",
    role: "Editor",
    status: "Active",
    lastLogin: "3d ago",
    avatar: "DR",
  },
  {
    id: 5,
    name: "Emma Johnson",
    email: "emma@thynkprocess.com",
    role: "Viewer",
    status: "Inactive",
    lastLogin: "12d ago",
    avatar: "EJ",
  },
];
